import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { fetchVehicle } from '../../actions';
import { selectVehicle } from '../../selectors';
import styled from 'styled-components';
import { COLOR_GREY_LIGHT } from '../../../../vars';
import { Loader } from '../../../../components/Loader';
import { formatLicensePlate } from '../../../../utils/string';
import cn from 'classnames';
import styles from './VehicleCreateInfoCard.module.css';

const CardContainer = styled.div`
  min-width: 450px;
  margin: 10px 0 10px 24px;
  padding: 24px 24px;
  background-color: #f1f2fe;
  color: gray;
  font-weight: 600;
  border-radius: 0.375rem;
  h2 {
    font-size: 14px;
    text-transform: uppercase;
  }
`;

const CardInfoList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    display: flex;
    justify-content: space-between;
    padding: 15px 50px 15px 24px;

    border-bottom: 3px solid #fff;

    text-transform: capitalize;

    .value {
      width: 40%;
    }
  }
  li:hover {
    border-bottom: 3px solid #0183D5;
  }
`;

class VehicleCreateInfoCard extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    if (!this.props.createdVehicle) {
      this.props.fetch();
    }
  }

  render() {
    if (!this.props.createdVehicle) return <Loader small="true" />;
    return (
      <CardContainer className={styles.container}>
        <h2 className='mb-2'>{this.lbl(`vehicle.info.data.vehicle_info`)}</h2>
        <CardInfoList>
          {this.props.data.map(
            (data_item, index) =>
              this.props.createdVehicle[data_item] && (
                <li className={styles.listItem} key={`${data_item}_${index}`}>
                  <span>{this.lbl(`vehicle.create.${data_item}`)}</span>{' '}
                  {data_item === 'regplate' ? (
                    <span className="value">{formatLicensePlate(this.props.createdVehicle[data_item])}</span>
                  ) : data_item === 'mileage' ? (
                    <span className="value">
                      {parseInt(this.props.createdVehicle[data_item] || '0').toLocaleString() + ' km'}
                    </span>
                  ) : (
                    <span className="value">{this.props.createdVehicle[data_item]}</span>
                  )}
                </li>
              ),
          )}
        </CardInfoList>
      </CardContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    createdVehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicle_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateInfo = compose(withConnect, withRouter)(VehicleCreateInfoCard);
